<template>
  <div class="pa-6 main-layout">
    <div>
      <v-row>
        <v-col cols="8" class="d-flex">
          <router-link to="/app/admin/company/" style="text-decoration: none">
            <h4 class="text-capitalize font-weight-bold text_color--text">
              company
            </h4>
          </router-link>
          <span class="mx-3">/</span>
          <h4 class="text-capitalize font-weight-bold primary--text">
            details
          </h4>
        </v-col>
        <v-col cols="4" class="text-right d-flex justify-end">
          <router-link
            :to="{ name: 'company' }"
            class="mx-2 px-3 py-1"
            style="text-decoration: none"
          >
            <h4 class="text-capitalize font-weight-bold text_color--text">
              Daily
            </h4>
          </router-link>
          <router-link
            :to="{ name: 'company' }"
            class="mx-2 px-3 py-1"
            style="text-decoration: none"
          >
            <h4 class="text-capitalize font-weight-bold text_color--text">
              Monthly
            </h4>
          </router-link>
          <router-link
            :to="{ name: 'company' }"
            class="mx-2 px-3 py-1 white"
            style="text-decoration: none"
          >
            <h4 class="text-capitalize font-weight-bold text_color--text">
              All time
            </h4>
          </router-link>
        </v-col>
      </v-row>
    </div>
    <v-row class="ma-0 py-2">
      <v-col cols="12" md="3" ld="3" class="pa-1">
        <section>
          <v-card class="mb-4" elevation="0">
            <v-row no-gutters class="pa-2" v-if="companyDetails">
              <v-col
                cols="12"
                md="3"
                lg="4"
                class="pa-2"
                v-if="companyDetails.logo"
              >
                <v-img contain :src="companyDetails.logo" />
              </v-col>
              <v-col cols="12" md="3" lg="4" class="pa-2" v-else>
                <v-img contain :src="companyImage" cover />
              </v-col>
              <v-col cols="12" md="7" lg="8" class="py-2">
                <div>
                  <h4 v-if="companyDetails.name">
                    <BaseTooltip
                      title="company name"
                      :text="companyDetails.name"
                    />
                  </h4>
                </div>

                <v-row no-gutters>
                  <v-col cols="6">
                    <h5 class="text_color--text">Status</h5>
                  </v-col>
                  <v-col cols="6">
                    <h5 class="text_color--text">Contact No</h5>
                  </v-col>
                  <v-col cols="6">
                    <v-chip
                      small
                      :color="companyDetails.is_active ? 'green' : 'unassigned'"
                      class="text_color--text"
                    >
                      {{ companyDetails.is_active ? "Active" : "Deactivated" }}
                    </v-chip>
                  </v-col>
                  <v-col cols="6">
                    <h5
                      class="text_color--text"
                      v-if="companyDetails.contact_number"
                    >
                      {{ companyDetails.contact_number }}
                    </h5>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>

          <v-card elevation="0" class="my-4">
            <v-card-title class="px-3 py-1">
              <v-row no-gutters>
                <v-col cols="6">
                  <h6>Company Details</h6>
                </v-col>
                <v-col cols="6" class="text-right">
                  <router-link
                    style="text-decoration: none"
                    :to="{
                      name: 'edit-company',
                      params: { id: $route.params.id },
                    }"
                  >
                    <v-icon class="primary--text" small>mdi-pencil</v-icon>
                  </router-link>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-subtitle>
              <div v-if="companyDetails && companyDetails.company_details">
                <v-row
                  no-gutters
                  v-for="(value, key, index) in companyDetails.company_details"
                  :key="index"
                  class="pt-1 px-2"
                >
                  <v-col md="5" lg="6" v-if="key">
                    <h5 class="text_color--text text-capitalize">
                      {{ key.replace(/_/g, " ") }}
                    </h5>
                  </v-col>
                  <v-col md="7" lg="6">
                    <h5>{{ value }}</h5>
                  </v-col>
                </v-row>
              </div>
            </v-card-subtitle>
          </v-card>

          <v-card elevation="0" class="my-3">
            <v-card-title class="px-3 py-1">
              <v-row no-gutters>
                <v-col cols="6">
                  <h6>Subscription Details</h6>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-subtitle
              class="subscription-details"
            >
              <div v-if="subscriptionValidityStatistics">
                <v-row
                  no-gutters
                  v-for="(value, key, index) in subscriptionValidityStatistics"
                  :key="index"
                  class="pt-1 px-1"
                >
                  <v-col cols="12" v-if="key">
                    <v-progress-linear :value="value" rounded height="20">
                      <h5 class="text-body-2 font-weight-bold text-capitalize">
                        {{ key.replace(/_/g, " ") }}
                      </h5>
                    </v-progress-linear>
                  </v-col>
                  <v-col cols="6">
                    <CompanyDetailsSmallCard text="Used" textValue="50%" />
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <CompanyDetailsSmallCard text="Unused" textValue="50%" />
                  </v-col>
                  <v-divider class="mx-1 mb-1"></v-divider>
                </v-row>
              </div>
            </v-card-subtitle>
          </v-card>
        </section>
      </v-col>

      <v-col cols="12" md="6" lg="6" class="pa-1">
        <section>
          <SingleCompanyTripCard
            mainTitle="order stat"
            :imageSrc="CardTop1"
            icon="mdi-archive"
            text="total orders"
            textValue="2332"
            iconColor="warning lighten-1"
          />
          <v-row class="ma-0 pa-0">
            <v-col cols="4">
              <CompanyDetailsSmallCard
                text="Avg. Monthly Orders"
                textValue="34343"
              />
            </v-col>
            <v-col cols="4">
              <CompanyDetailsSmallCard
                text="Avg. Weekly orders"
                textValue="434"
              />
            </v-col>
            <v-col cols="4">
              <CompanyDetailsSmallCard
                text="Avg. Daily Orders"
                textValue="123"
              />
            </v-col>
          </v-row>

          <SingleCompanyTripCard
            mainTitle="Trip stat"
            :imageSrc="CardTop2"
            icon="mdi-truck-fast"
            text=" total Trips"
            textValue="323"
            iconColor="error lighten-1"
          />

          <v-row class="pa-0 ma-0">
            <v-col cols="4">
              <CompanyDetailsSmallCard
                text="Avg. Monthly Trips"
                textValue="434"
              />
            </v-col>
            <v-col cols="4">
              <CompanyDetailsSmallCard
                text=" Avg. Weekly Trips"
                textValue="203"
              />
            </v-col>
            <v-col cols="4">
              <CompanyDetailsSmallCard
                text=" Avg. Daily Trips"
                textValue="50"
              />
            </v-col>
          </v-row>

          <SingleCompanyTripCard
            mainTitle="Fleet stat"
            :imageSrc="CardTop3"
            text="Avg Fleet Utilizations"
            textValue="54%"
          />

          <v-row class="pa-0 ma-0">
            <v-col cols="6">
              <v-card elevation="0" class="pa-2 rounded-lg">
                <v-row>
                  <v-col cols="2" class="d-flex align-center justify-center">
                    <v-icon color="text_color lighten-1" large>
                      mdi-account
                    </v-icon>
                  </v-col>
                  <v-col cols="10">
                    <h1>34</h1>
                    <h5 class="font-weight-light text-capitalize">
                      total drivers
                    </h5>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card elevation="0" class="pa-2 rounded-lg">
                <v-row>
                  <v-col cols="2" class="d-flex align-center justify-center">
                    <v-icon color="text_color lighten-1" large>
                      mdi-truck
                    </v-icon>
                  </v-col>
                  <v-col cols="10">
                    <h1>34</h1>
                    <h5 class="font-weight-light text-capitalize">
                      total Vehicles
                    </h5>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="ma-0 pa-0">
            <v-col cols="4" class="d-flex">
              <v-card outlined class="px-3 info lighten-2 rounded-lg w-100">
                <v-card-title class="my-3">
                  <v-icon large color="sub_heading"> mdi-truck-fast </v-icon>
                </v-card-title>
                <v-card-subtitle class="py-4" v-if="this.companyDetails">
                  <h1>{{ this.companyDetails.total_trip_plans }}</h1>
                  <h4 class="font-weight-normal text-capitalize my-1">
                    total Trip Plan
                  </h4>
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="4" class="d-flex">
              <v-card outlined class="px-3 accent lighten-3 rounded-lg w-100">
                <v-card-title class="my-3">
                  <v-icon color="text_color lighten-3" large>
                    mdi-truck-fast
                  </v-icon>
                </v-card-title>
                <v-card-subtitle class="py-4">
                  <h1 class="text_color--text">400</h1>
                  <h4
                    class="
                      font-weight-normal
                      text_color--text
                      text-capitalize
                      my-1
                    "
                    style="opacity: 0.7"
                  >
                    Avg Monthly Trip Plan
                  </h4>
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="4" class="d-flex">
              <v-card outlined class="px-3 rounded-lg w-100">
                <v-card-title class="my-3">
                  <v-icon color="primary lighten-1" large>
                    mdi-truck-fast
                  </v-icon>
                </v-card-title>
                <v-card-subtitle class="py-4">
                  <h1 class="text_color--text">16</h1>
                  <h4
                    class="
                      blue--text
                      font-weight-normal
                      text_color--text
                      text-capitalize
                      my-1
                    "
                    style="opacity: 0.7"
                  >
                    Avg Daily Trip Plan
                  </h4>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-col>

      <v-col cols="12" md="3" lg="3" class="pa-1">
        <v-card
          class="card-box-shadow mb-3"
          elevation="0"
          ref="vehicleLogsElement"
          id="vehicle-logs-target"
        >
          <v-card-title class="px-3 py-1">
            <v-row no-gutters>
              <v-col cols="6">
                <h6>Logs</h6>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="logs-component">
            <div v-scroll:#vehicle-logs-target="onDriverLogsScroll">
              <Logs :logs="driverLogs" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";
import DialogBase from "@/components/BaseComponents/DialogBase.vue";
import Logs from "@/components/BaseComponents/Logs.vue";
import BaseSmallTripDetail from "@/components/BaseComponents/BaseSmallTripDetail.vue";
import DocumentListForm from "@/components/GeneralComponents/DocumentListForm.vue";
import companyImage from "@/assets/defaultLogo.png";
import CardTop1 from "@/assets/CardTop1.png";
import CardTop2 from "@/assets/CardTop2.png";
import CardTop3 from "@/assets/CardTop3.png";
import SingleCompanyTripCard from "@/components/ModuleBasedComponents/Company/SingleCompanyTripCard.vue";
import CompanyDetailsSmallCard from "@/components/ModuleBasedComponents/Company/CompanyDetailsSmallCard.vue";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";

export default {
  components: {
    BaseDetailLayout,
    DialogBase,
    Logs,
    BaseSmallTripDetail,
    DocumentListForm,
    CompanyDetailsSmallCard,
    SingleCompanyTripCard,
    BaseTooltip,
  },
  data() {
    return {
      subscriptionValidityDetails: null,
      CardTop1,
      CardTop2,
      CardTop3,
      companyImage,
      tab: 0,
      companyDetails: {
        company_details: {
          account_manager: "Raad Patel",
          address: "Dubai, United Arab Emirates",
          website: "wwww.google.com",
        },
      },
      subscriptionDetails: {
        subscription_model: "SAAS",
        duration: "25/12/22 to 24/12/25",
        module: "Trip, Order, Driver, Vehicle, Item, Trip Planning",
      },
      subscriptionValidityStatistics: {
        trip: "50",
        order: "50",
        driver: "50",
        vehicle: "50",
        item: "50",
        trip_planning: "50",
      },
      companyStatisticsIcons: {
        customers: "mdi-account-multiple-outline",
        warehouse: "mdi-warehouse",
        items: "mdi-database",
        branches: "mdi-family-tree",
        users: "mdi-account",
        roles: "mdi-account-check",
        total_drivers: "mdi-truck",
        total_vehicles: "mdi-truck-fast",
      },
      companyStatistics: {
        customers: "344",
        warehouse: "120",
        items: "19300",
        branches: "34",
        users: "11",
        roles: "5",
      },

      driverAnalyticsColor: {
        average_delay_time: "pickedup",
        joined_on: "failed",
        last_days_trips: "on_hold",
        total_order: "trip_active",
        total_trips: "partially_delivered",
      },
      driverAnalyticsIcon: {
        average_delay_time: "mdi-timer",
        joined_on: "mdi-account-multiple-outline",
        last_days_trips: "mdi-truck",
        total_order: "mdi-archive",
        total_trips: "mdi-truck-fast",
      },

      driverLogs: [],
    };
  },

  methods: {
    onDriverLogsScroll(e) {
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll < 4 && this.isDriverLogsScrollable) {
        this.isDriverLogsScrollable = false;
        this.getDriverLogs();
      }
    },
    getCompanyStatistics(id) {
      this.$api.company
        .getCompanyStatistics(id)
        .then((res) => {
          this.companyDetails = res.data;
          if (this.companyDetails) {
            this.companyStatistics = {
              customers: this.companyDetails?.total_customers,
              items: this.companyDetails?.total_items,
              branches: this.companyDetails?.total_branches,
              warehouse: this.companyDetails?.total_warehouses,
              users: this.companyDetails?.total_users,
              roles: this.companyDetails?.total_roles,
            };
            this.companyDetails.company_details = {
              account_manager: this.companyDetails?.account_manager,
              remarks: this.companyDetails?.remarks,
              website: this.companyDetails?.website,
              address: this.companyDetails?.address,
            };
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      this.getCompanyStatistics(this.$route.params.id);
    }
  },
};
</script>

<style scoped>
.main-layout {
  height: 90vh;
  overflow: hidden;
}

.logs-component {
  height: calc(100vh - 180px);
  overflow-y: auto;
}
.subscription-details {
  height: 45vh;
  overflow-y: auto;
}
</style>
